import React, { useRef } from 'react';
import classNames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import AnimatedContainer from 'components/AnimatedContainer';
import useClickOutSide from 'hooks/useClickOutSide';
import useCallbackRef from 'hooks/useCallbackRef';

const propTypes = {};

/**
 *
 * @param {Object} props
 * @param {string} props.idTarget - REQUIRED
 * @param {boolean} props.isOpen - REQUIRED
 * @param {JSX} props.render - REQUIRED
 * @param {string} props.className
 * @param {Object} props.style
 * @param {() => void} props.onClickOutSide
 * @returns
 */
const Dropdown = ({ className, isOpen, render, style, onClickOutSide, idTarget }) => {
  //! State
  const containerRef = useRef();
  const onClickOutSideRef = useCallbackRef(onClickOutSide);
  useClickOutSide(containerRef, (event) => {
    const target = event.target || event.srcElement;
    if (target?.id === idTarget) {
      return;
    }

    onClickOutSideRef && onClickOutSideRef.current(event);
  });

  //! Function

  //! Render
  return (
    <AnimatePresence>
      {isOpen && (
        <AnimatedContainer
          className={classNames('component:Dropdown default-border bg-color-white', className)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 10000,
            boxShadow: '0 2px 8px rgba(0,0,0,.2)',
            ...style,
          }}
        >
          <div className='content' ref={containerRef}>
            {render}
          </div>
        </AnimatedContainer>
      )}
    </AnimatePresence>
  );
};

Dropdown.propTypes = propTypes;
export default Dropdown;
